export default __webpack_public_path__ + "static/media/jangwon_nft_8.d9881861.svg";